import React, { useState, useRef, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import Select from "react-select";
import {ContextApi} from "../../../App"

function MultiSelect({ onMoveDown, onMoveUp, onElementDelete, preset }) {
  //States
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "multiSelect",
    properties: {
      label: "MultiSelect field.",
      options: [],
      value:[],
    },
    multiple: false,
    required: false,
    fillableByCandidate: true,
    fillableByHR: false,
  });
  const contextData = useContext(ContextApi)
  const [options, setOptions] = useState([]);

  const [modal, setModal] = useState(false);

  useEffect(() => {
    let formBuilderElements = [
      ...document.querySelectorAll(".form-builder-element"),
    ];
    formBuilderElements = formBuilderElements.map((element) =>
      JSON.parse(element.getAttribute("data"))
    );
  
    
  });

  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementAnswerRef = useRef();
  // const elementMultipleRef = useRef();
  const elementRequiredRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
      if (preset.properties) setOptions(preset.properties.options);
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);
  function onEdit() {
    setElement((previousState) => {
      previousState.properties.label = elementLabelRef.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      // previousState.required = elementRequiredRef.current.checked;
      // previousState.properties.multiple = elementMultipleRef.current.checked;
      previousState.properties.options = options;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit :!contextData.contextData.isEdit
    })
  }

  function onAddNewAnswer(event) {
    if (elementAnswerRef.current.value !== "") {
      setOptions((state) => {
        state = [...state, elementAnswerRef.current.value];
        elementAnswerRef.current.value = "";
        return state;
      });
    } else {
      swal("Drop-down should not be empty");
    }
  }

  function onDeleteOption(event) {
    const value = event.target.getAttribute("v");
    setOptions((state) => {
      let newState = [];
      for (let index = 0; index < state.length; index++) {
        const element = state[index];
        if (element !== value) {
          newState.push(element);
        }
      }
      return newState;
    });
  }
  
  
  return (
    <div
      className="form-group mb-3 form-builder-element"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e,element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>

      <label>
        {element.properties.label}
        {element.properties.required && <span style={{color:'red'}}>*</span>}
      </label>

        {/* {options.map((v, k) => (
          <option value={v} key={k}>
            {v}
          </option>
        ))} */}
        <Select
        isMulti
        //   value={{
        //     //label: value,
        //     label: value === null ? setValue(element.properties.value) : value,
        //     value: value,
        //   }}
          options={element.properties.options.map((option) => {
            return {
              label: option,
              value: option,
            };
          })}
        //   onChange={(e) => {
        //     setValue(e.value);
        //   }}
        //   isDisabled={
        //     data?.disableField &&
        //     data?.properties?.value?.length !== 0 &&
        //     localStorage.getItem("user.role") !== "admin"
        //       ? data?.disableField
        //       : readOnly
        //   }
        />
    
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Multi Select Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Question</label>
            <input
              ref={elementLabelRef}
              defaultValue={element.properties.label}
              type="text"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Answers</label>
            {options.map((v, k) => (
              <div className="mb-3" key={k}>
                {k + 1}. {v}{" "}
                <button
                  className="btn btn-sm btn-danger float-right"
                  v={v}
                  onClick={onDeleteOption}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
          <div className="form-group">
            <div className="input-group">
              <input
                ref={elementAnswerRef}
                type="text"
                className="form-control"
              />
              <div className="input-group-append">
                <button className="btn btn-primary" onClick={onAddNewAnswer}>
                  Add
                </button>
              </div>
            </div>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory
            </label>
          </div>
          {/* <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementMultipleRef}
              className="custom-control-input"
              id="multipleCheck"
            />
            <label className="custom-control-label" htmlFor="multipleCheck">
              Multiple Select Options
            </label>
          </div> */}
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default MultiSelect;
